document.addEventListener('DOMContentLoaded', () => {

  window.runScroll = (el, o = 0) => {
    if (!el || el === '#') return;
    const targetEl = document.querySelector(el);
    if (!targetEl) return;

    const topbar = document.querySelector('.js-topbar');
    const yOffset = topbar ? -topbar.clientHeight : 0;
    const targetY = targetEl.getBoundingClientRect().top + window.scrollY + yOffset;

    const startY = window.scrollY;
    const distance = targetY - startY;
    const duration = 600; // ms
    let startTime = null;

    const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, startY + distance * easeOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  };

  document.querySelectorAll('a[href*="#"]').forEach(link => {
    link.addEventListener('click', e => {
      const href = link.getAttribute('href');

      // blokujemy tylko realne anchory
      if (!href || href === '#' || !href.startsWith('#')) return;

      e.preventDefault();
      window.runScroll(href);
    });
  });

}, false);
